import React from "react";

export const ArrowButton = (props) => 
  {
    const textColor = props.textColor || "black";
  return (
    <>
      <a 
        // target="blank"
        href={`${props.url}`}
        className={`primary-btn-blck ${props.className} flex link-hover`}
        style={{
          fontSize: 12,
          color: props.textColor,
          textDecoration: "none",
          color: textColor, 
          
        }}
      >
        <div
          className="flex border-circle font-bold align-items-center justify-content-center"
          style={{
            backgroundColor: props.bgColor,
            width: "33px",
            height: "33px",
            color: props?.arrowColor,
          }}
        >
          <i
            className="pi pi-arrow-right"
            style={{ fontSize: "14px", fontWeight: "800" }}
          ></i>
        </div>
        <div
          className="ml-2 flex font-medium justify-content-center align-items-center"
          style={{
            fontSize: "1pc",
            fontWeight: "600",
            textTransform: "capitalize",
            color: textColor,
          }}
        >
          <span style={{fontSize:"1pc !important"}}>{props?.buttonText?.toLowerCase()}</span>
        </div>
      </a>
    </>
  );
};
